import Service from '@/helpers/service'

export default {

    get(params) {
        return Service().get('end-user-search-material/get_material_number', {params});
    },
}